import { gql } from "@apollo/client";
import { APICall } from "../api_helper";

export const CREATE_LIFE_DOMAIN = gql`
  mutation createLifeDomain(
    $session: String!
    $name: String!
    $parentLifeDomainId: Int
    $eventMetadata: EventMetadata!
  ) {
    createLifeDomain(
      session: $session
      name: $name
      parentLifeDomainId: $parentLifeDomainId
      eventMetadata: $eventMetadata
    ) {
      id
      name
      parentLifeDomain {
        id
        name
      }
    }
  }
`;

export const UPDATE_LIFE_DOMAIN: APICall = {
  documentNode: gql`
    mutation updateLifeDomain(
      $session: String!
      $id: Int!
      $name: String!
      $parentLifeDomainId: Int
      $eventMetadata: EventMetadata!
    ) {
      updateLifeDomain(
        session: $session
        id: $id
        name: $name
        parentLifeDomainId: $parentLifeDomainId
        eventMetadata: $eventMetadata
      ) {
        id
        name
        parentLifeDomain {
          id
          name
        }
      }
    }
  `,
  key: "updateLifeDomain",
};

export const DELETE_LIFE_DOMAIN: APICall = {
  documentNode: gql`
    mutation deleteLifeDomain(
      $session: String!
      $id: Int!
      $eventMetadata: EventMetadata!
      $isChildElement: Boolean!
      $parentDeletionStrategy: ParentDeletionStrategy
    ) {
      deleteLifeDomain(
        session: $session
        id: $id
        eventMetadata: $eventMetadata
        isChildElement: $isChildElement
        parentDeletionStrategy: $parentDeletionStrategy
      )
    }
  `,
  key: "deleteLifeDomain",
};

export const LIST_LIFE_DOMAINS = gql`
  query listLifeDomains($session: String!) {
    listLifeDomains(session: $session) {
      id
      name
      parentLifeDomain {
        id
        name
      }
      hasChildren
    }
  }
`;
